import React from 'react';
import { LabelInput, TextInput } from 'modules/v2/common/AtomicDesign/atoms';

import { TemplateFilePicker } from 'modules/v2/pages/TemplatesBuilder/shared-components/TemplateFilePicker';
import { FormData } from 'modules/v2/pages/TemplatesBuilder/utils/setupModalUtils';

interface Step2Props {
  formData: FormData;
  onFormDataChange: (data: any) => void;
}

export const isStep2Valid = (formData: FormData) => {
  // Step 2 is optional, so it's always valid
  return true;
};

export const Step2: React.FC<Step2Props> = ({ formData, onFormDataChange }) => {
  const handleFileUpload = (file: File) => {
    onFormDataChange({ ...formData, brokerLogo: file });
  };

  const handleInputChange = (field: string, value: string) => {
    onFormDataChange({ ...formData, [field]: value });
  };

  return (
    <div className="space-y-4">
      <div className="mb-12">
        <TemplateFilePicker
          label="Your Brokerage Logo"
          subLabel="Upload a logo that will appear on your marketing materials. Transparent PNG file recommended."
          name="broker-logo-upload"
          onChange={handleFileUpload}
          value={formData.brokerLogo}
        />
      </div>

      <div className={formData.brokerLogo ? 'mt-24' : 'mt-8'}>
        <LabelInput required={false}>Your Brokerage Name</LabelInput>
        <TextInput
          type="text"
          value={formData.brokerName}
          onChange={(e) => handleInputChange('brokerName', e.target.value)}
          placeholder="Enter your brokerage name"
        />
      </div>

      <p className="text-sm font-semibold text-[#252525] mt-4">
        You can <u>skip</u> this step by clicking "Next," if you don't want to add a logo or brokerage information.
      </p>
    </div>
  );
};

